export const PLATFORMS = {
  MEDIA: 'media',
  EVENTS: 'events',
};

const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

export function detectPlatform(location = window.location) {
  const hostname = location.hostname || '';

  if (hostname.endsWith('.bridged.events')) {
    return PLATFORMS.EVENTS;
  }

  const isLocal = LOCAL_HOSTS.includes(hostname);
  const isStg = hostname.startsWith('stg-portal.');

  if (isLocal || isStg) {
    const params = new URLSearchParams(location.search);
    if (params.get('platform') === PLATFORMS.EVENTS) {
      return PLATFORMS.EVENTS;
    }
  }

  return PLATFORMS.MEDIA;
}

export function isEventsPlatformValue(platform) {
  return platform === PLATFORMS.EVENTS;
}
